<script lang="ts">
  /**
   * MapOverlay — location list from the world graph.
   * Shows discovered locations. Full ASCII map rendering
   * will come once spatial data is populated by gameplay.
   */
  import { getWorldState } from "$lib/api/invoke";
  import type { WorldState } from "$lib/api/invoke";

  let worldState: WorldState | null = $state(null);
  let loading = $state(true);

  async function load(): Promise<void> {
    try {
      worldState = await getWorldState();
    } catch {
      worldState = null;
    }
    loading = false;
  }

  load();
</script>

<div class="map-overlay">
  <h2 class="map-overlay__title">MAP (M)</h2>

  <div class="map-overlay__border">+{"=".repeat(24)}+</div>

  <div class="map-overlay__content">
    {#if loading}
      <span class="map-overlay__empty">Loading...</span>
    {:else if worldState}
      <pre class="map-overlay__grid">
  +-----------+
  |           |
  |     @     |
  |           |
  +-----------+
      </pre>
      <p class="map-overlay__location">
        Current: {worldState.world_name}
      </p>
      <p class="map-overlay__info">
        Turn {worldState.turn} | {worldState.time}
      </p>
    {:else}
      <span class="map-overlay__empty">No world loaded.</span>
    {/if}
  </div>

  <div class="map-overlay__border">+{"=".repeat(24)}+</div>

  <div class="map-overlay__legend">
    <span class="map-overlay__legend-item">@ = You</span>
    <span class="map-overlay__legend-item">Spatial map populates as you explore</span>
  </div>
</div>

<style>
  .map-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
  }

  .map-overlay__title {
    color: var(--fg-bright);
    font-size: 1.1rem;
    letter-spacing: 0.15em;
  }

  .map-overlay__border {
    color: var(--fg-dim);
    font-size: 0.85rem;
  }

  .map-overlay__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .map-overlay__grid {
    font-size: 1rem;
    line-height: 1.3;
    color: var(--fg);
    letter-spacing: 0.2em;
  }

  .map-overlay__location {
    color: var(--fg-bright);
    font-size: 0.9rem;
  }

  .map-overlay__info {
    color: var(--fg-dim);
    font-size: 0.8rem;
  }

  .map-overlay__legend {
    display: flex;
    gap: 1.5rem;
    color: var(--fg-dim);
    font-size: 0.8rem;
    margin-top: 0.5rem;
  }

  .map-overlay__legend-item {
    white-space: nowrap;
  }

  .map-overlay__empty {
    color: var(--fg-dim);
    font-size: 0.85rem;
    text-align: center;
    padding: 1rem;
  }
</style>
